import * as storageTypes from "./storageTypes";

let menuStorage = {};

menuStorage.clear = () => localStorage.clear();

menuStorage.getMenu = () => {
  let result = JSON.parse(localStorage.getItem(storageTypes.MENU));
  return result;
};
menuStorage.setMenu = value => {
  localStorage.setItem(storageTypes.MENU, JSON.stringify(value));
};

menuStorage.getShortCutMenu = () => {
  let result = JSON.parse(localStorage.getItem(storageTypes.SHORTCUTMENU));
  return result;
};
menuStorage.setShortCutMenu = value => {
  localStorage.setItem(storageTypes.SHORTCUTMENU, JSON.stringify(value));
};

export default menuStorage;
